import { useUserInfo } from "@next-platform/client-common-core";
import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";
import { ButtonIcon, ButtonSize, ButtonVariant, IconVariants, Shape } from "@next-platform/client-common-spicy-ui";
import AnnounceKit from "announcekit-react";
import { useEffect } from "react";

import { APPLICATIONS_ID } from "@/constants";

const WIDGET_KEY = {
  [APPLICATIONS_ID.SpicyChat]: "1j9lRe",
  [APPLICATIONS_ID.PixelChat]: "3Ce0yQ",
  [APPLICATIONS_ID.SecretMate]: "K6ali",
};

enum Platform {
  BROWSER = "browser",
  IOS = "ios",
  ANDROID = "android",
}
export default (function AnnouncekitNotification() {
  const { email, username, userId: user_id, role: currentTier, platform: subscriptionPlatform, status: subscriptionStatus } = useUserInfo();
  const applicationId = basicAppConfig.applicationId;
  const widgetKey = WIDGET_KEY[applicationId as keyof typeof WIDGET_KEY];
  useEffect(() => {
    if (window.LogRocket?.identify && user_id) {
      window.LogRocket.identify(user_id, {
        email: email ?? "",
        username: username ?? "",
        tier: currentTier ?? "",
      });
    }
  }, [email, user_id, username, currentTier]);

  if (!user_id || !widgetKey) {
    return null;
  }

  return (
    <AnnounceKit
      widget={`https://announcekit.co/widgets/v2/${widgetKey}`}
      user={{
        id: user_id!,
        name: username,
        email: email,
      }}
      data={{
        userType: currentTier,
        platform: Platform.BROWSER,
        subscriptionPlatform: subscriptionPlatform,
        subscriptionStatus: subscriptionStatus,
      }}
      floatWidget={false}
      widgetStyle={{
        fontSize: "16px",
        marginTop: "0px",
        right: 0,
        position: "absolute",
      }}
    >
      <ButtonIcon icon={IconVariants.BELL} size={ButtonSize.MEDIUM} shape={Shape.SQUARE} variant={ButtonVariant.TEXT} aria-label="notifications" />
    </AnnounceKit>
  );
});
